import { themeVars } from '@dreamtree-org/landing-kit/schema';
import { applyBrand } from './applyTheme';
import { themePaletteVars } from './colorChannels';

const THEME_KEY = 'dreamtree-theme'; // twreact-ui ThemeProvider's saved light/dark choice

function setHeadLink(id, attrs) {
  let el = document.getElementById(id);
  if (!attrs) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('link');
    el.id = id;
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

function setMeta(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * Apply a store's theme (landing-kit `validateTheme` shape) to the whole storefront:
 * the generated palette onto the app's --color-primary-50…950 and twreact-ui's
 * --dt-primary-50…950 (accent palette → --dt-secondary-50…950), the corner radius,
 * the font pair (stylesheet loaded only when the pair needs one), the favicon,
 * theme-color, and the store's default light/dark mode unless the shopper chose one.
 * `mediaUrl(ref)` resolves the logo/favicon upload to a URL.
 */
export function applyStoreTheme(theme, { mediaUrl = () => null } = {}) {
  if (!theme || typeof document === 'undefined') return null;
  const v = themeVars(theme);
  applyBrand({
    ...themePaletteVars(v.palette),
    '--radius': v.style['--dt-lp-radius'],
    '--store-font': v.font.body,
    '--store-font-heading': v.font.heading,
  });
  document.body.style.fontFamily = v.font.body;
  setHeadLink('store-font', v.font.href ? { rel: 'stylesheet', href: v.font.href } : null);
  const favicon = v.theme.favicon && mediaUrl(v.theme.favicon);
  setHeadLink('store-favicon', favicon ? { rel: 'icon', href: favicon } : null);
  setMeta('theme-color', v.theme.primary);
  let chosen = null;
  try {
    chosen = localStorage.getItem(THEME_KEY);
  } catch {
    chosen = null;
  }
  if (!chosen && v.theme.mode !== 'auto') document.documentElement.setAttribute('data-theme', v.theme.mode);
  return v;
}
